function Stages5() {
	return ( 
		<div>
			<div>
				<p>
					Die Holzstruktur wird rissig und instabil.
				</p>
			</div>
		</div>
	 );
}

export default Stages5;